import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 项目全局配置参数
        config: window.config
    },
    getters: {
        /**
         * 获取全局配置参数
         */
        config: (state) => (key) => {
            if (key !== undefined) {
                return state.config[key] !== undefined ? state.config[key] : ''
            } else {
                return state.config
            }
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js